import { mergeMap } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { Types, Creators } from '../ducks/diagnostic';
import { Api } from '../../api';

// eslint-disable-next-line
export const saveDiagnosticData = action$ => {
  return action$.pipe(
    ofType(Types.SAVE_DIAGNOSTIC_DATA_REQUESTED),
    mergeMap((({ diagnosticData }) => Api.postDiagnosticData(diagnosticData)
      .then(res => Creators.saveDiagnosticDataSuccess(res))
      .catch(err => Creators.saveDiagnosticDataError(err))
    )),
  );
};

export const sendDiagnostic = action$ => action$.pipe(
  ofType(Types.SEND_DIAGNOSTIC_REQUESTED),
  mergeMap((({ data }) => Api.postDiagnosticEmail(data)
    .then(res => Creators.sendDiagnosticSuccess(res))
    .catch(err => Creators.sendDiagnosticError(err))
  )),
);

export const sendAvailabilityData = action$ => action$.pipe(
  ofType(Types.SEND_AVAILABILITY_DATA_REQUESTED),
  mergeMap((({ data }) => Api.postAvailabilityData(data)
    .then(res => Creators.sendAvailabilityDataSuccess(res))
    .catch(err => Creators.sendAvailabilityDataError(err))
  )),
);

const epicList = [
  saveDiagnosticData,
  sendDiagnostic,
  sendAvailabilityData,
];

export default epicList;
